<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-time-based-ad-location-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Location
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="(errors.name || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: { TextFormGroup},

  mixins: [Errors],

  props: {
    timeBasedAdLocation: {
      required: true
    }
  },

  data() {
    return {
      data: {}
    }
  },

  watch: {
    timeBasedAdLocation() {
      this.data = {...this.timeBasedAdLocation.attributes}
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/time-based-ad-locations/' + this.timeBasedAdLocation.id, {
        ...this.data
      })
          .then(response => {
            notify.success('The location was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.timeBasedAdLocation.attributes}
    }
  }
}
</script>
